import React from 'react';

import { useTranslation } from 'react-i18next';

import { ReactComponent as DownLeftArrow } from '../../../../../../assets/icons/v3/down-left-arrow.svg';
import { ReactComponent as UpRightArrow } from '../../../../../../assets/icons/v3/out.svg';
import BdsActivityPill from '../../../../../../shared/components/v3/BdsActivityPill/BdsActivityPill';
import BdsCircleIndicatorPictogram from '../../../../../../shared/components/v3/BdsCircleIndicator/BdsCircleIndicatorPictogram/BdsCircleIndicatorPictogram';
import BdsDivider from '../../../../../../shared/components/v3/Globals/BdsDivider/BdsDivider';
import { TRANSLATIONS_BENEFIT_CATEGORIES } from '../../../../../../shared/constants/benefits';
import { IHealthReport } from '../../../../../../shared/interfaces/reports';
import { TRANSLATIONS_REPORTS } from '../../../../../../shared/translations/reports';
import { categoryKeys } from '../../../../../../shared/types/benefitTypes';
import './BenefitsData.scss';

export const BenefitsData = ({ data, isMexico }: { data: IHealthReport; isMexico: boolean }) => {
  const { t } = useTranslation();

  const renderComparisons = (value: number) => {
    if (data.isFirstReport) return;
    if (value >= 0) {
      return (
        <BdsActivityPill
          variant="filled"
          className="bd-pill positive"
          pictogram={{ component: UpRightArrow }}
          label={<div>{value + '%'}</div>}
        />
      );
    }
    return (
      <BdsActivityPill
        variant="filled"
        className="bd-pill negative"
        pictogram={{ component: DownLeftArrow }}
        label={<div>{Math.abs(value) + '%'}</div>}
      />
    );
  };

  return (
    <div className="benefits-data-container">
      <div className="health-report-section-subtitle bd-title-container">
        {t(TRANSLATIONS_REPORTS.healthReport.benefitsData.title)}
      </div>
      {data.topBenefits?.length > 0 && (
        <div className="bd-benefits-container">
          {data.topBenefits.map((benefit, index) => (
            <div className="bd-benefit-item" key={benefit.providerName}>
              <BdsCircleIndicatorPictogram
                circleIndicatorSize="m"
                pictogram={{ url: benefit.providerLogo }}
                className="bd-icon"
              />
              <div className="bd-text-container">
                <div className="bd-benefit-name">{benefit.providerName}</div>
                <div className="bd-benefit-category">
                  {benefit?.category ? t(TRANSLATIONS_BENEFIT_CATEGORIES[benefit.category as categoryKeys]) : ''}
                </div>
                <BdsActivityPill
                  variant="filled"
                  className="bd-benefit-value"
                  label={<div>{benefit.percentage + '%'}</div>}
                />
              </div>
              <div className={`bd-rectangle color-${index + 1}`} />
            </div>
          ))}
        </div>
      )}
      <div className="health-report-section-subtitle bd-title-container">
        {t(TRANSLATIONS_REPORTS.healthReport.benefitsData.healthProtection).toUpperCase()}
      </div>
      <div className="bd-info">
        {!isMexico && (
          <div className="bd-info-item">
            <div className="bd-info-value">{`${data.marketcareBenefitPercentage}%`}</div>
            <div className="bd-info-label">{t(TRANSLATIONS_REPORTS.healthReport.benefitsData.pharmacy)}</div>
            {renderComparisons(data.marketcareBenefitInsight)}
          </div>
        )}
        <div className="bd-info-item">
          <div className="bd-info-value">{`${data.medismartBenefitPercentage}%`}</div>
          <div className="bd-info-label">{t(TRANSLATIONS_REPORTS.healthReport.benefitsData.telemedicine)}</div>
          {renderComparisons(data.medismartBenefitInsight)}
        </div>
      </div>
      <BdsDivider size="s" color="high" />
    </div>
  );
};

export default BenefitsData;
